// @flow
import React from 'react';
import { Label } from 'semantic-ui-react';

import { StyledSpan } from '../../../common-utils/styledComponents';

export const CNBCRibbonContainer = ({ isSystemGenerated, isAddedByAdmin }) => (
  <StyledSpan
    style={{
      marginLeft: '-4rem',
      marginTop: '0.5rem',
      position: 'absolute',
    }}
  >
    <Label color="teal" ribbon={true}>
      {isSystemGenerated ? 'SG' : isAddedByAdmin ? 'Ad' : 'NA'}
    </Label>
  </StyledSpan>
);
